import app from '@/app';

function filter() {
	return items => Object.keys(items).length;
}

app.filter('keysLength', filter);
